import CreateLPRepositoryImpl from './impl/CreateLPRepositoryImpl'

export default {
  getInstance () {
    return new CreateLPRepositoryImpl()
  }
}
